import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const DPContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  '.title': {
    fontWeight: 'bold',
    fontsize: '20rem',
    color: `${v.ezMainColor}`
  },

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  '@media only screen and (min-width: 600px)': {
    '.rowFields': {
      flexDirection: 'row',
    },
  },

  '@media only screen and (min-width: 769px)': {
    '.rowFields': {
      flexDirection: 'row',
    },
  },
})

export const Cont = styled.div({
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid rgba(34,36,38,.15)',
  borderRadius: '.28571429rem',
  padding: '0.2rem 0.5rem',
  minHeight: '10rem',

  '.title': {
    fontWeight: 'bold',
    fontsize: '20rem',
    color: `${v.ezMainColor}`
  },

  '.stBold': {
    fontWeight: 'bold'
  },

  '.rowI': {
    display: 'flex',
    '>div:first-child': {
      flex: 2.5,
      marginRight: '0.2rem'
    },
    '>div': {
      flex: 1
    }
  }
});
